// components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-gray-100 text-gray-700 py-6 mt-10">
            <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-4">
                <p className="text-sm">&copy; {new Date().getFullYear()} I-com.LLC: Բոլոր իրավունքները պաշտպանված են:</p>

                <div className="flex space-x-4 text-sm">
                    <a href="#contact" className="text-gray-700 hover:text-black">
                        կապ մեզ հետ
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
